import { render, staticRenderFns } from "./applicationConfig.vue?vue&type=template&id=5d71c1a4&scoped=true"
import script from "./applicationConfig.vue?vue&type=script&lang=js"
export * from "./applicationConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71c1a4",
  null
  
)

export default component.exports